import { post } from '../../../services/request';

export const login = data => post('Login/UserLogin', data);
export const resetPassword = data => post('Login/ResetPassword', data);
export const forgetPassword = data => post('Login/ForgetPassword', data);
export const forgetPasswordReset = data => post('Login/ForgetPasswordReset', data);
export const verifyMfa = data => post('Login/VerifyMfa', data);



